function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { fetchAdjustmentReasonTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import LocaleKeys from '../../../locales/keys';
import { retrieveAdjustmentDetails, retrieveAndOpenBillAdjustmentStatement } from '../../../reducers/actions/customer.billing.actions';
import { CurrentCustomerAccountingMethodSelector, CurrentCustomerIdSelector, IsPIIDataAccessEnabledSelector, RouteParams } from '../../../reducers/selectors/customer.selectors';
import { AdjustmentItemsTableDataSelector, AdjustmentOrCreditNoteDetailsSelector, AdjustmentReasonsCodeSelector, IsFetchingAdjustmentDetailsSelector } from '../../../reducers/selectors/customer.billing.selectors';
import { getAdjustmentCodeNames } from '../../../reducers/selectors/customer.billing.selectors.helper';
import { ACCOUNTING_METHODS_NAMES, TAX_TYPE } from '../../../reducers/constants/billing.payments.constants';
import { BILL_ADJUSTMENT, CONVERSION_CREDIT_ADJUSTMENT, CONVERSION_DEBIT_ADJUSTMENT, CREDIT_NOTE_ADJUSTMENT, DEBIT_NOTE_ADJUSTMENT, MISC_ADJUSTMENT } from '../../billingPayments/billing.payments.constants';
var CreditNoteDetailsController = /*#__PURE__*/function () {
  function CreditNoteDetailsController($filter, $ngRedux, $timeout, $scope, uiNotificationService) {
    _classCallCheck(this, CreditNoteDetailsController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      $scope: $scope,
      ACCOUNTING_METHODS_NAMES: ACCOUNTING_METHODS_NAMES,
      BILL_ADJUSTMENT: BILL_ADJUSTMENT,
      CONVERSION_CREDIT_ADJUSTMENT: CONVERSION_CREDIT_ADJUSTMENT,
      CONVERSION_DEBIT_ADJUSTMENT: CONVERSION_DEBIT_ADJUSTMENT,
      CREDIT_NOTE_ADJUSTMENT: CREDIT_NOTE_ADJUSTMENT,
      DEBIT_NOTE_ADJUSTMENT: DEBIT_NOTE_ADJUSTMENT,
      LocaleKeys: LocaleKeys,
      MISC_ADJUSTMENT: MISC_ADJUSTMENT,
      uiNotificationService: uiNotificationService
    });
    $scope.datatable = {
      getAdjustmentType: this.getAdjustmentType.bind(this)
    };
  }
  return _createClass(CreditNoteDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentReasonCodes: AdjustmentReasonsCodeSelector(store),
          adjustmentReasonCodesLoaded: MetadataCodeLoadedSelector(CODES.ADJUSTMENT_REASON_TYPE_CODE, store),
          creditNoteDetails: AdjustmentOrCreditNoteDetailsSelector(store),
          currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          isFetchingAdjustmentDetails: IsFetchingAdjustmentDetailsSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          routeParams: RouteParams(store),
          tableData: AdjustmentItemsTableDataSelector(store)
        };
      };
      var controllerActions = {
        fetchAdjustmentReasonTypes: fetchAdjustmentReasonTypes,
        retrieveBillAdjustmentAndOpenInNewTab: retrieveAndOpenBillAdjustmentStatement,
        retrieveAdjustmentDetails: retrieveAdjustmentDetails
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.adjustmentReasonCodesLoaded) {
        this.actions.fetchAdjustmentReasonTypes();
      }
      this.columnDefs = this.getTableHeaders();
      this.applyCreditNoteModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.applyCreditNoteModalApi = api;
        }
      };
      this.retrieveCreditNoteDetails();
    }
  }, {
    key: "getAdjustmentType",
    value: function getAdjustmentType(invoiceNumber, debitNoteAdjustmentNumber, paymentReceiptNumber) {
      if (invoiceNumber) {
        return i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_TOOLTIP);
      }
      if (debitNoteAdjustmentNumber) {
        return i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.ADJUSTMENT_DETAILS);
      }
      if (paymentReceiptNumber) {
        return i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.PAYMENT_ID_TOOLTIP);
      }
      return;
    }
  }, {
    key: "showApplyNoteButton",
    value: function showApplyNoteButton() {
      return this.state.currentCustomerAccountingMethod === this.ACCOUNTING_METHODS_NAMES.OPEN_INVOICE && this.creditNoteSummary && this.creditNoteSummary.RemainingBalance !== 0 && convertStringToNumber(this.creditNoteSummary.AdjustmentTypeCode) === this.CREDIT_NOTE_ADJUSTMENT;
    }
  }, {
    key: "getTableHeaders",
    value: function getTableHeaders() {
      return [{
        field: 'id',
        displayName: i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_ADJUSTMENT_PAYMENT_ID),
        cellTemplate: require('./cellTemplates/invoice.template.html'),
        enableSorting: false
      }, {
        field: 'date',
        displayName: i18n.translate(LocaleKeys.DATE),
        enableSorting: false
      }, {
        field: 'amount',
        displayName: i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.AMOUNT_PAID),
        cellTemplate: require('./cellTemplates/amount.template.html'),
        enableSorting: false
      }, {
        field: 'balance',
        displayName: i18n.translate(LocaleKeys.BALANCE),
        cellTemplate: require('./cellTemplates/balance.template.html'),
        enableSorting: false
      }];
    }
  }, {
    key: "retrieveCreditNoteDetails",
    value: function retrieveCreditNoteDetails() {
      var _this2 = this;
      this.creditNoteDetailsRequest = {
        customerId: this.state.currentCustomerId,
        request: {
          AdjustmentId: this.state.routeParams.creditNoteId
        }
      };
      this.actions.retrieveAdjustmentDetails(this.creditNoteDetailsRequest).then(function () {
        _this2.creditNoteSummary = _this2.state.creditNoteDetails.AdjustmentSummary;
        _this2.adjustmentType = _this2.creditNoteSummary && convertStringToNumber(_this2.creditNoteSummary.AdjustmentTypeCode);
        _this2.reasonCodeName = _this2.creditNoteSummary && getAdjustmentCodeNames(_this2.creditNoteSummary.AdjustmentReasonCode, _this2.state.adjustmentReasonCodes ? _this2.state.adjustmentReasonCodes.items : []);
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "openApplyCreditNoteModal",
    value: function openApplyCreditNoteModal() {
      var _this3 = this;
      this.creditNoteData = {
        adjustmentCode: this.reasonCodeName,
        amount: this.creditNoteSummary.OriginalBalance,
        creditNoteId: this.creditNoteSummary.AdjustmentId,
        currencyCode: this.creditNoteSummary.CurrencyCode,
        referenceId: this.creditNoteSummary.AdjustmentNumber,
        remainingBalance: this.creditNoteSummary.RemainingBalance
      };
      this.showApplyCreditNoteModal = true;
      this.$timeout(function () {
        _this3.applyCreditNoteModalApi.open();
      });
    }
  }, {
    key: "onApplyCreditNoteModalClose",
    value: function onApplyCreditNoteModalClose() {
      this.retrieveCreditNoteDetails();
      this.applyCreditNoteModalApi.close();
      this.showApplyCreditNoteModal = false;
    }
  }, {
    key: "buildBillAdjustmentRequest",
    value: function buildBillAdjustmentRequest() {
      return {
        CustomerId: this.state.routeParams.customerId,
        AdjustmentId: this.creditNoteSummary.AdjustmentId,
        request: {
          AccountNumber: this.creditNoteSummary.AccountNumber,
          StatementDate: this.creditNoteSummary.DateCreated,
          StatementNumber: this.creditNoteSummary.AdjustmentNumber,
          StatementType: 1
        }
      };
    }
  }, {
    key: "getTaxMethodName",
    value: function getTaxMethodName(taxMethod) {
      if (!taxMethod) {
        return null;
      }
      return taxMethod === TAX_TYPE.INCLUSIVE ? i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INCLUSIVE) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.EXCLUSIVE);
    }
  }, {
    key: "generateStatementFlag",
    value: function generateStatementFlag() {
      return this.creditNoteSummary.hasOwnProperty('StatementEnabled');
    }
  }, {
    key: "retrieveAdjustmentContent",
    value: function retrieveAdjustmentContent() {
      this.actions.retrieveBillAdjustmentAndOpenInNewTab(this.buildBillAdjustmentRequest());
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./credit.note.details.template.html'),
  controller: CreditNoteDetailsController,
  controllerAs: 'CreditNoteDetailsController'
};